export default __webpack_public_path__ + "static/media/inActiveHeaderCart.c27896f3.svg";